"use client";

import dynamic from "next/dynamic";

export const FAQListWrapper = dynamic(() => import("./FAQList").then(mod => mod.FAQList));
